import { styled } from "@mui/material/styles";
import StyledRadioIcon from "../StyledRadioIcon/StyledRadioIcon";

const StyledRadioChecked = styled(StyledRadioIcon)(({ theme }) => ({
  backgroundColor: theme.palette["primary"]["60"],
  backgroundImage: "linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))",
  "&:before": {
    display: "block",
    width: 18,
    height: 18,
    backgroundImage: "radial-gradient(#fff,#fff 18%,transparent 20%)",
    content: "\"\"",
  },
  "input:hover ~ &": {
    backgroundColor: theme.palette["primary"]["60"],
  },
}));

export default StyledRadioChecked;